<template>
    <span id="spanBG" v-show="$parent.IsLogged()" class="background__custom" style="display: none"></span>
</template>
<script>
    import $ from 'jquery';
    import { Utility } from '../../configs/configpaths';
    export default {
        data: function () {
            return {
                image: '',
                show: false
            };
        },

        mounted: function () {
            this.SetBackGround();
        },
        methods: {
            Hide: function () {
                $("#spanBG").hide();
                const el = document.body;
                this.show = false;

                el.classList.remove("showBgImage");
                $("#spanBG").css("background-image", "url('')");
            },
            SetBackGround: function () {
                var _self = this;
                _self.show = false;
                var CURRENT_USER = Utility.GetCurrent();
               
                const el = document.body;
                el.classList.remove("showBgImage");
                if (CURRENT_USER !== null) {
                    var file_id = parseInt(CURRENT_USER.BgImageUrl);
                    if (!isNaN(file_id) && file_id > 0) {
                        var default_url = _self.$parent.GetPathFileId(file_id);
                        _self.show = true;

                        el.classList.add("showBgImage");

                        $("#spanBG").css("background-image", "url('" + default_url.replace(/(\r\n|\n|\r)/gm, "") + "')");


                    }
                }
                else {
                    $("#spanBG").css("background-image", "url('')");
                }
            }
        }

    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
